import { Component } from '@angular/core';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { AgregarEmpleadosBase } from 'src/app/shared/agregar-empleados/agregar-empleados-base';

// Angular core y formularios
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

// Angular Material
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core'; // ⬅ Necesario para que funcione el datepicker con fechas nativas

// Módulo de búsqueda dentro de mat-select
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';

// DataTables para Angular



@Component({
    selector: 'app-add-emp-proy',
    templateUrl: './add-emp-proy.component.html',
    styleUrls: ['../modal-agregar-proyecto.component.css'],
    standalone: true,
    imports: [
      CommonModule,
      FormsModule,
      ReactiveFormsModule,
      RouterModule,
      MatFormFieldModule,
      MatInputModule,
      MatSelectModule,
      MatIconModule,
      MatButtonModule,
      MatTooltipModule,
      MatDialogModule,
      MatDatepickerModule,
      MatNativeDateModule,
      NgxMatSelectSearchModule,
      DragDropModule
    ]

})
export class AsigEmpComponent extends AgregarEmpleadosBase {}
